module.exports = __webpack_public_path__ + "img/register_btn.0f5fb31d.png";